import { authorTracksDeleted } from '@/entities/tracks'
import { showDeleteConfirmationModal } from '@/shared/lib/antd-utils'
import { DeleteOutlined } from '@ant-design/icons'
import { Button, Col, Form, Row } from 'antd'
import { useUnit } from 'effector-react'

import type { AuthorEditorTabProps } from '..'

export const AuthorSettingsTab = ({
  author: { id: authorId },
}: AuthorEditorTabProps) => {
  const deleteAuthorTracks = useUnit(authorTracksDeleted)
  const handleDeleteAuthorTracks = () => {
    showDeleteConfirmationModal({
      onConfirm: () => {
        deleteAuthorTracks({ authorId })
      },
      options: {
        title: 'Удаление',
        content: 'Вы уверены, что хотите удалить все треки автора?',
        okText: 'Удалить',
      },
    })
  }

  return (
    <>
      <Row gutter={[undefined, 24]}>
        <Col span={24}>
          <Form.Item layout="vertical" label="Опасные опции">
            <Button
              onClick={handleDeleteAuthorTracks}
              icon={<DeleteOutlined style={{ color: 'red' }} />}
            >
              Удалить все треки
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </>
  )
}
